<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <v-container class="toolbar__container">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <MultiplaEscolha
              ref="unidadesSelect"
              lazy
              get-url="getUnidadeslazy"
              :items="semUnidadeOption"
              v-bind:selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <MultiplaEscolha
              ref="linhasSelect"
              lazy
              get-url="getLinhaslazy"
              v-bind:selected-items.sync="linhasSelecionadas"
              text="cod_linha"
              value="id_linha"
              :label="$t('tripOperation.line')"
              :max-items="2"
            />
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-text-field
              v-model="dti"
              type="date"
              :label="$t('speedReport.startDate')"
              :max="dtf || undefined"
              :rules="[regraData]"
            />
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-text-field
              v-model="dtf"
              type="date"
              :label="$t('speedReport.endDate')"
              :min="dti || undefined"
              :rules="[regraData]"
            />
          </v-col>
          <v-col cols="12" sm="4" md="2" align="end">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  @click="populaRelatorio"
                  style="margin-bottom: 5px;"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("operation.search") }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <MerusDataTable
      :headers="headers"
      :items="itens"
      :loading="loading"
      :default-multi-sort="defaultSort"
      :server-items-length="total"
      :items-per-page="numberOfRows"
      :items-per-page-last-option="itemsPerPageLastOption"
      :server-sort-by="serverSortBy"
      :server-sort-desc="serverSortDesc"
      item-key="key"
      @update:options="onTableOptions"
      @update:filters="onFiltersUpdate"
    >
      <template v-slot:toolbar>
        <CadastroToolbar
          :title="$t('relMotoristaVeiculo.title')"
          :items="itens"
          :load-items-for-export="loadItemsForExport"
          background-export
          csv-title="motoristaveiculo"
          :pdf-title="$t('relMotoristaVeiculo.title')"
          :pdf-headers="headers"
          pdf-filename="relmotoristaveiculo"
          hide-search
        />
      </template>
    </MerusDataTable>
  </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import {
  buildRequestParams,
  computePageState,
  fetchAllServerPagesForExport,
  initSortFromDefault,
  samePageAndSort,
} from '@/utils/serverTablePagination';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';

function chave(item) {
  return [item.id_unidade, item.id_linha, item.matricula_motorista, item.id_veiculo, item.data_referencia, item.id_turno].join('|');
}

function isoDate(d) {
  return d.toISOString().substring(0, 10);
}

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
    MultiplaEscolha,
  },
  data: () => ({
    loading: false,
    formValidado: false,
    itens: [],
    total: 0,
    numberOfRows: 10,
    itemsPerPageLastOption: 1000,
    lastItemsPerPageBeforeTodos: null,
    pageNumber: 1,
    serverSortBy: [],
    serverSortDesc: [],
    columnFilters: {},
    // Filtros do momento da busca: paginar/ordenar não pega alterações ainda não aplicadas.
    filtrosAplicados: null,
    requisicaoAtual: 0,
    unidadesSelecionadas: [],
    linhasSelecionadas: [],
    dti: null,
    dtf: null,
  }),
  computed: {
    headers() {
      const col = (text, value, extra = {}) => ({ text, value, sortable: true, ...extra });
      const texto = { filtrable: true };
      return [
        col(this.$t('relMotoristaVeiculo.headers.day'), 'dia'),
        col(this.$t('relMotoristaVeiculo.headers.shift'), 'descricao_turno', texto),
        col(this.$t('nav.registration.units'), 'descricao_unidade', texto),
        col(this.$t('tripOperation.line'), 'cod_linha', texto),
        col(this.$t('relMotoristaVeiculo.headers.lineName'), 'nome_linha', { ...texto, sortable: false }),
        col(this.$t('employee.headers.registration'), 'matricula_motorista', texto),
        col(this.$t('tripOperation.driver'), 'nome_motorista', texto),
        col(this.$t('tripOperation.vehicle'), 'numero_ordem', texto),
        col(this.$t('relMotoristaVeiculo.headers.trips'), 'qtd_viagens'),
        col(this.$t('relMotoristaVeiculo.headers.km'), 'km_rodado'),
        col(this.$t('relMotoristaVeiculo.headers.firstTrip'), 'primeiro_horario'),
        col(this.$t('relMotoristaVeiculo.headers.lastTrip'), 'ultimo_horario'),
      ];
    },
    defaultSort() {
      return [
        { value: 'descricao_unidade', options: { text: this.$t('system.labels.increasing'), value: 1 } },
      ];
    },
    semUnidadeOption() {
      return [{ id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' }];
    },
  },
  created() {
    const hoje = new Date();
    const inicio = new Date();
    inicio.setDate(hoje.getDate() - 7);
    this.dti = isoDate(inicio);
    this.dtf = isoDate(hoje);
    const initialSort = initSortFromDefault(this.defaultSort);
    this.serverSortBy = initialSort.serverSortBy;
    this.serverSortDesc = initialSort.serverSortDesc;
  },
  beforeDestroy() {
    this.requisicaoAtual += 1;
  },
  methods: {
    regraData(v) {
      return !!v || this.$t('contract.messages.selectDate');
    },
    populaRelatorio() {
      this.$refs.form.validate();
      if (!this.formValidado) {
        return;
      }
      // Sem seleção explícita o backend já restringe ao escopo do usuário.
      this.filtrosAplicados = {
        idunidades: this.unidadesSelecionadas.map(Number),
        idlinhas: this.linhasSelecionadas.map(Number),
        dti: this.dti,
        dtf: this.dtf,
      };
      this.pageNumber = 1;
      this.carrega();
    },
    estadoPaginacao() {
      return {
        pageNumber: this.pageNumber,
        numberOfRows: this.numberOfRows,
        serverSortBy: this.serverSortBy,
        serverSortDesc: this.serverSortDesc,
        searchFilters: this.columnFilters,
        lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
        total: this.total,
      };
    },
    onTableOptions(options) {
      if (this.loading || !options || !this.filtrosAplicados) return;
      if (!samePageAndSort(options, this.estadoPaginacao())) this.carrega(options);
    },
    onFiltersUpdate(filters) {
      const next = filters || {};
      if (JSON.stringify(next) === JSON.stringify(this.columnFilters)) return;
      this.columnFilters = next;
      this.pageNumber = 1;
      if (this.filtrosAplicados) this.carrega();
    },
    async carrega(options) {
      if (!this.filtrosAplicados) return;
      const state = this.estadoPaginacao();
      const request = buildRequestParams(options, state);
      const requisicao = ++this.requisicaoAtual;
      this.loading = true;
      try {
        const response = await apiController.request(apiController.endpoints.getRelatoriomotoristaveiculo, {
          data: { ...this.filtrosAplicados, ...request.params },
        });
        // Resposta de uma busca/página já substituída.
        if (requisicao !== this.requisicaoAtual) return;
        const data = response.data || {};
        this.itens = (data.items || []).map((item) => ({ ...item, key: chave(item) }));
        const updates = computePageState(data, request, state, this.itemsPerPageLastOption);
        this.total = updates.total;
        this.pageNumber = updates.pageNumber;
        this.numberOfRows = updates.numberOfRows;
        this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos;
        this.serverSortBy = updates.serverSortBy;
        this.serverSortDesc = updates.serverSortDesc;
      } catch (_err) {
        // O apiController já exibe o erro.
        if (requisicao !== this.requisicaoAtual) return;
        this.itens = [];
        this.total = 0;
      } finally {
        if (requisicao === this.requisicaoAtual) {
          this.loading = false;
        }
      }
    },
    async loadItemsForExport(onProgress) {
      if (!this.filtrosAplicados) {
        return [];
      }
      return fetchAllServerPagesForExport({
        fetchPage: async (params) => {
          const response = await apiController.request(apiController.endpoints.getRelatoriomotoristaveiculo, {
            data: { ...this.filtrosAplicados, ...params },
            silent: true,
          });
          return response && response.data;
        },
        state: {
          total: this.total,
          serverSortBy: this.serverSortBy,
          serverSortDesc: this.serverSortDesc,
          searchFilters: this.columnFilters,
        },
        onProgress,
      });
    },
  },
};
</script>
